import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const IncidentCard = ({ color }) => (
  <div
    className={classnames('w-4 h-6 inline-block shadow-xs rounded-sm', {
      'bg-gray-200 border-gray-700': !['red', 'yellow'].includes(color),
    })}
    style={{
      backgroundColor: color === 'yellow' ? '#F9C22E' : color === 'red' ? '#D62828' : undefined,
    }}
  />
);

IncidentCard.propTypes = {
  color: PropTypes.oneOf(['yellow', 'red']),
};

IncidentCard.defaultProps = {
  color: '',
};

export default IncidentCard;
